import { eudoraTheme, gbInstitucionalTheme, revendedoresTheme } from '@grupoboticario/flora';
import { FloraProvider as FloraProviderGlobal } from '@grupoboticario/flora-react';
import config from 'config';
import { BUSINESS_UNITS } from 'core/domains';

export const FloraProvider = ({ children }: { children?: React.ReactNode }): JSX.Element => {
  type StoreName = keyof typeof storeName;

  const storeName = {
    [BUSINESS_UNITS.EUD]: eudoraTheme,
    [BUSINESS_UNITS.BOT]: revendedoresTheme,
    [BUSINESS_UNITS.VDI]: gbInstitucionalTheme,
  };

  const theme = storeName[config.app.short as StoreName] || eudoraTheme;

  return (
    <FloraProviderGlobal theme={theme} resetCSS={false}>
      {children}
    </FloraProviderGlobal>
  );
};
